import Phaser from 'phaser';
import type { Hole } from './Playfield';
import { HOLE_RADIUS } from './Playfield';
import { palette } from '../design/palette';

const TARGET_DISPLAY_DIAMETER = HOLE_RADIUS * 2;  // matches inner hole fill size

export function createTargetGlow(scene: Phaser.Scene, hole: Hole): Phaser.GameObjects.Image {
  const img = scene.add.image(hole.x, hole.y, 'hole-sprite')
    .setDisplaySize(TARGET_DISPLAY_DIAMETER, TARGET_DISPLAY_DIAMETER)
    .setTint(palette.targetCore)
    .setTintMode(Phaser.TintModes.FILL);

  img.enableFilters();

  // outerStrength 4 / innerStrength 0 / quality 10 / distance 16 matches the soft halo
  // band of the old triple-circle stack within ~1 frame visually.
  const glow = img.filters?.internal.addGlow(palette.targetHalo, 4, 0, 1, false, 10, 16);
  // Expand the filter framebuffer past the 18×18 Image bounds so the 16px halo
  // doesn't get clipped to a hard square. distance + 2 for a safety margin.
  glow?.setPaddingOverride(-18, -18, 18, 18);

  if (glow) {
    const tween = scene.tweens.add({
      targets: glow,
      outerStrength: { from: 3, to: 6 },
      duration: 1100,
      yoyo: true,
      repeat: -1,
      ease: 'Sine.easeInOut',
    });
    // Phaser's TweenManager doesn't auto-stop tweens whose target is a destroyed
    // Filters.Controller (it lacks `isDestroyed`). Tie tween lifetime to the Image.
    img.once(Phaser.GameObjects.Events.DESTROY, () => tween.stop());
  }

  return img;
}
